var _switch;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContentDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 1000 1000",
    viewBox: "0 0 1000 1000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    height: 1,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/",
    width: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 500,
    fill: "#382b73",
    r: 398
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 500,
    fill: "#473080",
    r: 344.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m719.3 301.7-207.3 46.7h-212.6c-13.8 0-25 11.2-25 25v246.7c0 13.8 11.2 25 25 25h131.7v13.3 37.1h-16.2c-13 0-23.6 9.9-24.9 22.5 0 .1-.1.1-.1.2v.5 1.8 6.1.4c0 2.6 2.1 4.6 4.6 4.6h.4 158 .4c2.6 0 4.6-2.1 4.6-4.6v-.4-6.1-1.8c0-.2 0-.3 0-.5 0-.1-.1-.1-.1-.2-1.2-12.6-11.9-22.5-24.9-22.5h-16.2v-37.1-13.3h131.7c13.8 0 25-11.2 25-25v-220.4z",
    fill: "#382b73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m648.4 625.1h-349c-13.8 0-25-11.2-25-25v-246.7c0-13.8 11.2-25 25-25h348.9c13.8 0 25 11.2 25 25v246.7c.1 13.8-11.1 25-24.9 25z",
    fill: "#ffc733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m647.3 617.5h-346.8c-11 0-20-9-20-20v-241.5c0-11 9-20 20-20h346.9c11 0 20 9 20 20v241.5c-.1 11.1-9 20-20.1 20z",
    fill: "#fede3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m632.6 585.7h-317.4c-11 0-20-9-20-20v-194.4c0-11 9-20 20-20h317.4c11 0 20 9 20 20v194.4c0 11-9 20-20 20z",
    fill: "#ffc733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m630.9 578.9h-314c-8.3 0-15-6.7-15-15v-191.7c0-8.3 6.7-15 15-15h314.1c8.3 0 15 6.7 15 15v191.7c-.1 8.3-6.8 15-15.1 15z",
    fill: "#2dbba5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m632 357.2h-316.2c-7.7 0-13.9 6.2-13.9 13.9v10.7c0-7.7 6.2-13.9 13.9-13.9h316.2c7.7 0 13.9 6.2 13.9 13.9v-10.7c0-7.7-6.2-13.9-13.9-13.9z",
    fill: "#00a58c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m532.9 675.5h-118c-13.8 0-25 11.2-25 25v6.1c0 2.8 2.2 5 5 5h158c2.8 0 5-2.2 5-5v-6.1c0-13.8-11.2-25-25-25z",
    fill: "#fede3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m538.4 687.6h-129c-8.2 0-15.4 4.2-19.5 10.6v.5 8.2c0 2.6 2.1 4.6 4.6 4.6h158.8c2.6 0 4.6-2.1 4.6-4.6v-8.2c0-.2 0-.3 0-.5-4.1-6.4-11.3-10.6-19.5-10.6z",
    fill: "#ffc733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.1 625.1h85.6v50.4h-85.6z",
    fill: "#ef5a9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.1 625.1h85.6v13.3h-85.6z",
    fill: "#a72973"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 473.9,
    cy: 601.3,
    fill: "#2dbba5",
    r: 9.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m473.9 607.1c-4.5 0-8.3-3.2-9.1-7.5-.1.6-.2 1.1-.2 1.7 0 5.1 4.2 9.3 9.3 9.3s9.3-4.2 9.3-9.3c0-.6-.1-1.2-.2-1.7-.8 4.3-4.6 7.5-9.1 7.5z",
    fill: "#00a58c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m647.3 336h-124.6l-56.4 12.7 2.8 2.6h163.4c11 0 20 9 20 20v62.8l14.8-31.5v-46.6c0-11-8.9-20-20-20z",
    fill: "#ffc733"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#00a58c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m570.3 482.1c-.1-.1-.2-.1-.3-.2-.3-.2-.7-.5-1.1-.7-.4-.2-.8-.4-1.2-.6-.1 0-.1 0-.2-.1-.4-.1-.8-.3-1.3-.4-3.2-.7-6.6.2-9.1 2.7l-62.9 62.4c-3.6 3.6-3.9 9.2-.9 13.2v.1c.2.3.5.6.8.9 2.4 2.4 5.7 3.3 8.8 2.8 2-.3 3.9-1.2 5.4-2.8l62.9-62.4c3.9-3.9 3.9-10.2.1-14.1-.3-.3-.7-.6-1-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m500.2 432.2c-.3-.3-.7-.6-1-.9-.1-.1-.2-.1-.3-.2-.3-.2-.7-.5-1.1-.7-.4-.2-.8-.4-1.2-.6-.1 0-.1 0-.2-.1-.4-.1-.8-.3-1.3-.4-3.2-.7-6.6.2-9.1 2.7l-62.9 62.4c-3.6 3.6-3.9 9.2-.9 13.2v.1c.2.3.5.6.8.9 2.4 2.4 5.7 3.3 8.8 2.8 2-.3 3.9-1.2 5.4-2.8l62.9-62.4c3.9-3.8 4-10.1.1-14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510.8 482.3c-.3-.3-.7-.6-1-.9-.1-.1-.2-.1-.3-.2-.3-.2-.7-.5-1.1-.7-.4-.2-.8-.4-1.2-.6-.1 0-.1 0-.2-.1-3.5-1.2-7.6-.5-10.4 2.3l-38 37.6c-3.6 3.6-3.9 9.2-.9 13.2 0 0 0 0 .1.1.2.3.5.6.8.9 2.4 2.4 5.7 3.3 8.8 2.8 2-.3 3.9-1.2 5.4-2.8l38-37.6c3.8-3.8 3.9-10.1 0-14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m645.9 372.2c0-8.3-6.7-15-15-15h-155.3l43.3 39.4.5 81.1 45.6-35.7 57.4 56.6 23.6-50.4v-76z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m719.3 281.7-253 57 52.6 47.9 166.5-80.7-132.9 113.8 69.8 68.9z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m518.9 386.6.5 81.1 33.1-48 132.9-113.8z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m519.4 467.7 45.6-35.7-12.5-12.3z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.8 501.4c-3.1.5-6.4-.4-8.8-2.8-3.9-3.9-3.9-10.3.1-14.1l62.9-62.4c3.9-3.9 10.3-3.9 14.1.1 3.9 3.9 3.9 10.3-.1 14.1l-62.9 62.4c-1.4 1.5-3.3 2.4-5.3 2.7z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m467.4 526.8c-3.1.5-6.4-.4-8.8-2.8-3.9-3.9-3.9-10.3.1-14.1l38-37.6c3.9-3.9 10.3-3.9 14.1.1 3.9 3.9 3.9 10.3-.1 14.1l-38 37.6c-1.5 1.5-3.4 2.4-5.3 2.7z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m502.9 552.2c-3.1.5-6.4-.4-8.8-2.8-3.9-3.9-3.9-10.3.1-14.1l62.9-62.4c3.9-3.9 10.3-3.9 14.1.1s3.9 10.3-.1 14.1l-62.9 62.4c-1.4 1.5-3.3 2.4-5.3 2.7z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m500.2 422.2c-1.4-1.4-3.2-2.3-5-2.7 2.3 3.9 1.8 8.9-1.5 12.3l-62.9 62.4c-1.5 1.5-3.4 2.4-5.4 2.8-1.2.2-2.5.2-3.7-.1.4.7.9 1.3 1.5 1.9 2.4 2.4 5.7 3.3 8.8 2.8 2-.3 3.9-1.2 5.4-2.8l62.9-62.4c3.7-4 3.8-10.3-.1-14.2z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510.8 472.3c-1.4-1.4-3.2-2.3-5-2.7 2.3 3.9 1.8 8.9-1.5 12.3l-38 37.6c-1.5 1.5-3.4 2.4-5.4 2.8-1.2.2-2.5.2-3.7-.1.4.7.9 1.3 1.5 1.9 2.4 2.4 5.7 3.3 8.8 2.8 2-.3 3.9-1.2 5.4-2.8l38-37.6c3.7-4 3.8-10.3-.1-14.2z",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m571.3 473c-1.4-1.4-3.2-2.3-5-2.7 2.3 3.9 1.8 8.9-1.5 12.3l-62.9 62.4c-1.5 1.5-3.4 2.4-5.4 2.8-1.2.2-2.5.2-3.7-.1.4.7.9 1.3 1.5 1.9 2.4 2.4 5.7 3.3 8.8 2.8 2-.3 3.9-1.2 5.4-2.8l62.9-62.4c3.7-4 3.8-10.3-.1-14.2z",
    fill: "#d1d3d4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentDelivery);
export default __webpack_public_path__ + "static/media/content-delivery.c4652669c6c74f3c94bde8f93c1f3d7b.svg";
export { ForwardRef as ReactComponent };